import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep';

import FieldLabel from './FieldLabel';
import Model from './Model';
import SearchField from './SearchField';
import ToggleButton from './ToggleButton';

/*
	Mandatory properties:
	--------------------------
	items				[array]		Each item corresponds to a object in the list
									(IMPORTANT: without the model, directly its attributes).
									If less than 5, the search functionality will be disabled.

	Optional properties:
	--------------------------
	icon				[string]	The icon of the toggle buttons. "knk-tag" by default.

	color				[string]	The color of the buttons. "black" by default.

	filter_by			[array]		The key to search by each item.
									If missing, the search functionality will be disabled.

	selected			[array]		The ids of the items that are selected.
									If a string is passed, it will be automatically converted to an array of a single item.

	onToggle			[function]	The function to be called when an item is clicked.
									The ID of the item will be passed as a parameter.

	search_placeholder	[string]	The string of the search field placeholder.
									If missing, the default placeholder for the <SearchField /> will be present.
 */

const ToggleCollection = ({ items, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ filter, setFilter ] = useState({ search:"" });

	if(items == undefined || items === false) return null;

	const button_icon = props?.icon ?? 'knk-tag';
	const selected_color = props?.color ?? 'mainText';
	const filter_fields = props?.filter_by ?? false;
	const first = props?.first ?? false;
	const min = props?.min ?? 0;
	const max = props?.max ?? 1000;

	let selected_items = props?.selected || [];
	if(typeof selected_items !== 'object') selected_items = [selected_items];
	
	const filterItems = (k, v) => {
		setFilter({ ...filter, [k]:v });
	};

	const toggleItem = (id) => {
		if(props.onToggle != undefined) props.onToggle(id);
	};

	let filtered_items = items;
	if(filter_fields !== false && filtered_items !== false && filtered_items.length > 0) {
		filtered_items = items.filter((item) => {
			if(filter.search == "") return true;
			const filter_regexp = new RegExp(filter.search, 'i');

			let value_to_filter = [];
			filter_fields.map((i) => {
				value_to_filter.push(item[i]);
			});

			return filter_regexp.test(value_to_filter.join("_@@_"));
		});
	}

	let field_classes = ['react_field'];
	if(!first) field_classes.push('not_in_top');

	let classes = ['gui_labels_selector'];
	if(props.list_classes != undefined) classes.push(props.list_classes);
	if(props.children == undefined && !first) classes.push('gui_not_in_top');

	return (
		<div class={field_classes.join(" ")}>
			{(props.children != undefined) && (
				<FieldLabel>{props.children}</FieldLabel>
			)}

			{(filter_fields !== false && items.length >= 5) && (
				<Model model={filter} change={filterItems} classname="gui_not_in_bottom_tiny">
					<SearchField
						name="search"
						placeholder={props.search_placeholder}
						_class={{ first:true }}
					/>
				</Model>
			)}

			<div class={classes.join(" ")} style={props.style}>
				{filtered_items.map((item) => {
					const selected = (selected_items.includes(item.id)) ? true : false;

					let classes_selected = `selected ${selected_color}Button`;
					let classes_unselected = `not_selected`;
					if(button_icon !== false) {
						classes_selected += ` ${button_icon}`;
						classes_unselected += ` ${button_icon}`;
					}

					let enable_toggle = true;
					if(selected_items.length >= max && !selected) enable_toggle = false;

					return (
						<ToggleButton
							key={`toggle_${item.id}`}
							active={selected}
							secondary={(selected) ? false : true}
							color={(selected) ? false : null}
							main={(selected) ? true : false}
							icon={classes_selected}
							icon_off={classes_unselected}
							disabled={(enable_toggle) ? false : true}
							onClick={(enable_toggle) ? () => toggleItem(item.id) : null}
							autotranslate={item.autotranslate}
						>{item.title}</ToggleButton>
					)}
				)}
			</div>

			{(min > 0 && selected_items.length < min) && (
				<p class="redColor gui_not_in_top_tiny">
					{props.intl.formatMessage({
						id:"You need to select, at least, {num} item(s).",
					}, {
						num:min,
					})}
				</p>
			)}
		</div>
	)
};

export default injectIntl(ToggleCollection);